import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { VerifyEmailScreen } from '@/screens/accounts/SCR-103-verify-email'

// SCR-103 Verify your email (accounts area). Also where the emailed link lands (?verified=1 or ?error=…).
export const Route = createFileRoute('/_public/verify-email')({
  validateSearch: z.object({
    email: z.string().max(200).optional().catch(undefined),
    verified: z.coerce.number().optional().catch(undefined),
    error: z.string().max(100).optional().catch(undefined),
    next: z.string().max(2000).optional().catch(undefined),
  }),
  component: function VerifyEmail() {
    return <VerifyEmailScreen search={Route.useSearch()} />
  },
})
